import { Repository } from '../repository';
import { type TechniqueMitigation } from './entity';

export class TechniqueMitigations extends Repository<TechniqueMitigation> {
    getByTechniqueId(techniqueId: string): TechniqueMitigation[] {
        return this.items.filter(
            (techniqueMitigation) =>
                techniqueMitigation.techniqueId === techniqueId,
        );
    }
}
